// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import Vuex from 'vuex'
import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';
import theme from 'muse-ui/lib/theme';
import Loading from 'muse-ui-loading';
import Message from 'muse-ui-message';
import Toast from 'muse-ui-toast';
import Helpers from 'muse-ui/lib/Helpers';
import router from './router';
import axios from 'axios';
import {Encrypt} from "./utils/crypto.js";
import querystring from 'querystring';
import './assets/iconfont/iconfont.js';
import { post, get } from './utils/http';
import store from './store'
import globalData from './utils/global';
import './assets/stylus/index.styl';
import VueI18n from 'vue-i18n'

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(VueI18n)
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(MuseUI);
Vue.use(Loading);
Vue.use(Toast);
Vue.use(Message);
Vue.use(Helpers);
Vue.use(Vant);

Vue.prototype.querystring = querystring
Vue.prototype.$store = store
Vue.prototype.encrypt = Encrypt
Vue.prototype.$post = post
Vue.prototype.$get = get
Vue.prototype.$http = axios
Vue.prototype.global = globalData;
Vue.prototype.imageBaseUrl = globalData.baseUrl+"uploads/";
Vue.prototype.orderRediskey = globalData.orderRediskey;
Vue.prototype.buffetRediskey = globalData.buffetRediskey;
Vue.prototype.tableOrderInfo = globalData.tableOrderInfo;
Vue.prototype.handleFullScreen = globalData.handleFullScreen;
Vue.prototype.getItem = globalData.getItem;
Vue.prototype.setItem = globalData.setItem;
// 多语言实例
const i18n = new VueI18n({
    locale: (function () {
        if (localStorage.getItem('lang')) {
            return localStorage.getItem('lang')
        }
        return 'EN'
    }()),
    messages: {
        'EN': require('./assets/i18n/en'),   // 英文语言包
        'PT': require('./assets/i18n/pt'),   // 葡萄牙语言包
        'CN': require('./assets/i18n/cn'), // 中文语言包
        'DK': require('./assets/i18n/dk'), // 丹麦语言包
        '中文': require('./assets/i18n/cn') // 中文语言包
    }
})


// 自定义主题
theme.add('luckysushi', {
  primary: '#424242',
  secondary: '#FFFFFF',
  success: '#4caf50',
  warning: '#ffeb3b',
}, 'light');
theme.use('luckysushi');

/* eslint-disable no-new */
const app= new Vue({
  el: '#app',
    router,
    i18n,
   components: { App },
   template: '<App/>',
   store,
})
app.$mount()



// WEBPACK FOOTER //
// ./src/main.js